import { IconMarker } from './IconMarker'

export default IconMarker
